export default "__VITE_ASSET__DolIXImO__"